export default __webpack_public_path__ + "static/media/image.superb-business-solutions-pvt-ltd.41b77cb9.png";